import { Injectable } from '@angular/core';
import { ProxyDataService } from '@app/core/http';
import { appConstants } from '@app/common/app-constants';
import { AppConfigService } from '@app/common/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class MergePatientService {
  private prefixRegex = /[%|*]$/;
  private suffixRegex = /^[%|*]/;

  private MatchPrefix = 'prefix:';
  private MatchExact = 'exact:';
  private MatchSuffix = 'suffix:';

  constructor(private dataService: ProxyDataService, private appConfigService: AppConfigService) {}

  getPatientExams(mrn) {
    const params = {
      mrn: encodeURIComponent(this.buildServiceParamsWithWildcard(mrn))
    };
    return this.dataService.get(appConstants.appURLs.searchExams, params);
  }

  mergePatient(source, destination) {
    const params = {
      srcPatientCkey: encodeURIComponent(source.patientCkey),
      destnPatientCkey: encodeURIComponent(destination.patientCkey),
      userName: this.appConfigService.getUserId()
    };
    return this.dataService.create(appConstants.appURLs.mergePatient, params);
  }

  buildServiceParamsWithWildcard(searchCriteria) {
    const isPrefix = this.prefixRegex.test(searchCriteria);
    const isSuffix = this.suffixRegex.test(searchCriteria);
    if (isPrefix) {
      const lastIndex = searchCriteria.length - 1;
      return this.MatchPrefix + searchCriteria.trim().slice(0, lastIndex);
    }
    if (isSuffix) {
      return this.MatchSuffix + searchCriteria.trim().substr(1);
    }
    return this.MatchExact + searchCriteria;
  }

  getPatientList(pid = '', name = '', dob = '', gender = '') {
    let url = 'patients/multiDomain/search?';
    let paramUrl = '';
    paramUrl += this.buildParam('patientMrn', pid ? encodeURIComponent(this.buildServiceParamsWithWildcard(pid)) : pid);
    paramUrl += this.buildParam('patientName', name);
    paramUrl += this.buildParam('patientDob', dob);
    paramUrl += this.buildParam('patientGender', gender);
    if (paramUrl.startsWith('&')) {
      paramUrl = paramUrl.slice(1);
    }
    url += paramUrl;
    return this.dataService.getById(url);
  }

  buildParam(paramKey, paramValue) {
    return paramValue ? '&' + paramKey + '=' + paramValue : '';
  }
}
